import { Injectable } from '@angular/core';
import { LocalStorageManager } from '@examdojo/browser/local-storage';

export interface LastUsedTL2PageValue {
  topicLevel1Slug: string;
  topicLevel2Slug: string;
  /** The slug of the sub-page (e.g., 'core', 'practice') within the topic */
  pageSlug?: string;
}

type LastUsedTL2PageMap = Record<string, LastUsedTL2PageValue>;

const LAST_USED_TL2_PAGE_KEY = 'last_used_tl2_page';

@Injectable()
export class TopicSelectionPersistenceService {
  private readonly storageManager = new LocalStorageManager<LastUsedTL2PageMap>(LAST_USED_TL2_PAGE_KEY);

  getLastUsedPage(syllabusSlug: string, courseLevel: string | null): LastUsedTL2PageValue | null {
    const storedValue = this.storageManager.getValue();
    if (!storedValue) {
      return null;
    }
    const courseKey = this.getCourseKey(syllabusSlug, courseLevel);
    return storedValue[courseKey] ?? null;
  }

  setLastUsedPage(
    syllabusSlug: string,
    courseLevel: string | null,
    topicLevel1Slug: string,
    topicLevel2Slug: string,
    pageSlug?: string,
  ): void {
    const existingValue = this.storageManager.getValue() ?? {};
    const courseKey = this.getCourseKey(syllabusSlug, courseLevel);

    this.storageManager.setValue({
      ...existingValue,
      [courseKey]: { topicLevel1Slug, topicLevel2Slug, pageSlug },
    });
  }

  clearLastUsedPage(syllabusSlug: string, courseLevel: string | null): void {
    const existingValue = this.storageManager.getValue();
    if (!existingValue) {
      return;
    }
    const courseKey = this.getCourseKey(syllabusSlug, courseLevel);
    const { [courseKey]: _, ...rest } = existingValue;
    this.storageManager.setValue(rest);
  }

  private getCourseKey(syllabusSlug: string, courseLevel: string | null): string {
    return courseLevel ? `${syllabusSlug}_${courseLevel}` : syllabusSlug;
  }
}
